import { Card, CardContent } from "@/components/ui/card";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Quote } from "lucide-react";
export default function Testimonials() {
  const testimonials = [{
    id: 1,
    author: "Jane D.",
    position: "Patient",
    quote: "Excellent care and professional staff. My back pain has significantly improved."
  }, {
    id: 2,
    author: "Mark S.",
    position: "Patient",
    quote: "Highly recommend Align Physiotherapy for sports injuries. Very knowledgeable team."
  }];
  return <section className="py-16 md:py-24 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 animate-fade-in-up">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground mb-4 tracking-wide">
            What Our Patients Say
          </h2>
          <p className="text-muted-foreground text-base md:text-lg max-w-2xl mx-auto leading-[1.6]">
            Real feedback from real people who have experienced our evidence-based physiotherapy care.
          </p>
        </div>

        <div className="max-w-5xl mx-auto animate-fade-in-up-delay-100">
          <Carousel opts={{
          align: "start",
          loop: true
        }} className="w-full">
            <CarouselContent className="-ml-4">
              {testimonials.map((testimonial, i) => <CarouselItem key={testimonial.id} data-index={i} className="pl-4 md:basis-1/2 lg:basis-1/2">
                  <Card className="h-full border border-border shadow-soft hover:shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)]">
                    <CardContent className="p-8 flex flex-col h-full">
                      <div className="mb-6">
                        <Quote className="w-10 h-10 text-accent opacity-60" />
                      </div>
                      <blockquote className="flex-grow mb-6">
                        <p className="text-foreground text-base md:text-lg leading-[1.6] font-sans">
                          "{testimonial.quote}"
                        </p>
                      </blockquote>
                      <div className="border-t border-border pt-4">
                        <p className="font-display font-semibold text-foreground text-lg">
                          {testimonial.author}
                        </p>
                        <p className="text-muted-foreground text-sm mt-1">
                          {testimonial.position}
                        </p>
                      </div>
                    </CardContent>
                  </Card>
                </CarouselItem>)}
            </CarouselContent>
            <CarouselPrevious className="hidden md:flex -left-12 bg-primary text-primary-foreground hover:bg-primary-hover border-0 shadow-medium" />
            <CarouselNext className="hidden md:flex -right-12 bg-primary text-primary-foreground hover:bg-primary-hover border-0 shadow-medium" />
          </Carousel>
        </div>
      </div>
    </section>;
}